<gryf-navbar class="bg-success"></gryf-navbar>
<div class="bg-primary">
  <section class="section">
    <div class="container mt-3">
      <div class="row">
        <div class="col-12 col-md-3 offset-md-1 order-md-5">
          <div class="text-center">
            <svg class="error-img img-fluid mb-5 mb-md-0" width="1200px" height="1200px" viewBox="0 0 120 120"
                 xmlns="https://www.w3.org/2000/svg">
              <path d="M20 30 H 2.5 A 2.5 2.5 0 0 0 0 32.5 V 77.5 A 2.5 2.5 0 0 0 2.5 80 H 117.5 A 2.5 2.5 0 0 0 120 77.5 V 32.5 A 2.5 2.5 0 0 0 117.5 30 H 100" class="error-img-body" />
              <path d="M20 50 V 0 H 100 V 50 Z" class="error-img-paper" />
              <path d="M30 10 H 90" class="error-img-line" />
              <path d="M30 10 H 90" class="error-img-line" />
              <path d="M30 15 H 90" class="error-img-line" />
              <path d="M30 20 H 90" class="error-img-line" />
              <path d="M30 25 H 90" class="error-img-line" />
              <path d="M30 30 H 90" class="error-img-line" />
              <path d="M30 35 H 90" class="error-img-line" />
              <path d="M30 40 H 90" class="error-img-line" />
              <path d="M10 80 V 87.5 A 2.5 2.5 0 0 0 12.5 90 H 107.5 A 2.5 2.5 0 0 0 110 87.5 V 80" class="error-img-bottom" />
              <circle cx="95.5" cy="65" r="2.5" class="error-img-light error-img-light-success" />
              <circle cx="101.5" cy="65" r="2.5" class="error-img-light error-img-light-warning" />
              <circle cx="107.5" cy="65" r="2.5" class="error-img-light error-img-light-danger" />
              <path d="M15 90 V 120" class="error-img-stripe" />
              <path d="M20 90 V 120" class="error-img-stripe" />
              <path d="M25 90 V 120" class="error-img-stripe" />
              <path d="M30 90 V 120" class="error-img-stripe" />
              <path d="M35 90 V 120" class="error-img-stripe" />
              <path d="M40 90 V 120" class="error-img-stripe" />
              <path d="M45 90 V 120" class="error-img-stripe" />
              <path d="M50 90 V 120" class="error-img-stripe" />
              <path d="M55 90 V 120" class="error-img-stripe" />
              <path d="M60 90 V 120" class="error-img-stripe" />
              <path d="M65 90 V 120" class="error-img-stripe" />
              <path d="M70 90 V 120" class="error-img-stripe" />
              <path d="M75 90 V 120" class="error-img-stripe" />
              <path d="M80 90 V 120" class="error-img-stripe" />
              <path d="M85 90 V 120" class="error-img-stripe" />
              <path d="M90 90 V 120" class="error-img-stripe" />
              <path d="M95 90 V 120" class="error-img-stripe" />
              <path d="M100 90 V 120" class="error-img-stripe" />
              <path d="M105 90 V 120" class="error-img-stripe" />
            </svg>
          </div>
        </div>
        <div class="col-md-2 order-md-1">
          <div class="title text-danger">
            404 error page
          </div>
        </div>
        <div class="col-md-5 order-md-2">
          <h2 class="mb-4 text-white">
            Page <span class="text-danger">not</span> found
          </h2>
          <p class="text-muted">
            The page you are looking for is not here. It has either been moved or never existed. Please go to homepage and start from there instead.
          </p>
          <a href="#" class="btn btn-outline-primary text-white">
            Homepage <i class="fas fa-angle-right"></i>
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
<gryf-footer></gryf-footer>
